import { u as useComponentUuid } from "../../../composables/useComponentUuid.js";
const useSelectAria = () => {
  const id = useComponentUuid();
  const popupId = `combobox-controls-${id}`;
  return {
    popupId
  };
};
export {
  useSelectAria as u
};
//# sourceMappingURL=useSelectAria.js.map
